import { lazy } from 'react';

// After a redeploy, a tab opened earlier still references the previous
// build's hashed chunks, which no longer exist on the server — so the next
// lazy-loaded page fails to import. Reload once to pick up the new build;
// a timestamp in sessionStorage stops a reload loop if the chunk is truly
// broken (the error boundary then shows a message instead).

const KEY = 'pme_chunk_reload_at';
const WINDOW_MS = 15000;

export function reloadOnceForNewBuild() {
  let last = 0;
  try { last = Number(sessionStorage.getItem(KEY)) || 0; } catch { /* storage blocked */ }
  if (Date.now() - last < WINDOW_MS) return false;
  try { sessionStorage.setItem(KEY, String(Date.now())); } catch { /* storage blocked */ }
  window.location.reload();
  return true;
}

export const isChunkLoadError = (err) =>
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError|Loading chunk \S+ failed/i
    .test(String(err?.message || err));

export function lazyWithReload(importer) {
  return lazy(() => importer().catch((err) => {
    if (isChunkLoadError(err) && reloadOnceForNewBuild()) return new Promise(() => {}); // page is reloading
    throw err;
  }));
}

// Vite also reports failed preloads of a chunk's dependencies (CSS/JS).
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnceForNewBuild()) event.preventDefault();
});
